import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'lib-copy-to-clipboard',
  templateUrl: './copy-to-clipboard.component.html',
  styleUrl: './copy-to-clipboard.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CopyToClipboardComponent {
  private readonly transloco = inject(TranslocoService);
  @Input() value!: string;
  private _tooltip?: string;
  @Input() set tooltip(value: string | null | undefined) { this._tooltip = value ?? undefined; }
  get tooltip(): string { return this._tooltip ?? this.transloco.translate('copyToClipboard.copyToClipboard'); }

  async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.value);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  }
}
